import "./DashboardWhiteItem.scss"
import {convertCurrencyFormatPositiveNegative, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";

export default function DashboardWhiteItem(
    {
        colorIndex = 0,
        title = "",
        amount = 0

    }) {

    const backgrounds = [
        "backgroundColorCyan100",
        "backgroundColorIndigo100",
        "backgroundColorEmerald100",
        "backgroundColorPurple100",
        "backgroundColorViolet100",
        "backgroundColorBlue100",
        "backgroundColorSky100"
    ]


    return (
        <RaikoGridOneColumn className={"dashboardWhiteItemBaseContainer"}>
            <div className={`dashboardWhiteItemIconContainer ${backgrounds[colorIndex % 7]}`}>
                <div className={"ic-wallet"}/>
            </div>
            <span>{title}</span>
            <p>{`${amount === 0 ? 0 : convertCurrencyFormatPositiveNegative(amount / 10)} تومان `} </p>
        </RaikoGridOneColumn>
    )
}